import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Button, Popconfirm, Space } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface IProps {
  targetBlank?: boolean;
  hideDelete?: boolean;
  disableDelete?: boolean;
  hideEdit?: boolean;
  editLink?: string;
  editIcon?: React.ReactNode;
  onEdit?: (e: React.MouseEvent) => void;
  extraAction?: React.ReactNode;
  deleteModalTitle?: string;
  onDeleteModalOkClick?: () => void | Promise<void>;
}

export const ColumnActions: React.FC<IProps> = ({
  targetBlank = false,
  hideDelete = false,
  hideEdit = false,
  disableDelete = false,
  editLink,
  editIcon = <EditOutlined />,
  onEdit,
  extraAction,
  deleteModalTitle = '',
  onDeleteModalOkClick,
}) => {
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    if (!onDeleteModalOkClick) return;
    setDeleting(true);
    try {
      await onDeleteModalOkClick();
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Space>
      {extraAction}
      {!hideEdit && (() => {
        const btn = (
          <Button
            size="small"
            type="primary"
            icon={editIcon}
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.(e);
            }}
          >
            {L('Edit')}
          </Button>
        );
        return editLink ? (
          <Link to={editLink} target={(targetBlank && '_blank') || ''}>
            {btn}
          </Link>
        ) : btn;
      })()}
      {!hideDelete && (
        <Popconfirm
          title={L(deleteModalTitle)}
          onConfirm={handleConfirm}
          okText={L('Delete')}
          okButtonProps={{ danger: true }}
          cancelText={L('Cancel')}
          onPopupClick={(e) => e.stopPropagation()}
          disabled={deleting}
        >
          <Button
            size="small"
            danger
            type="primary"
            disabled={disableDelete || deleting}
            loading={deleting}
            icon={<DeleteOutlined />}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {L('Delete')}
          </Button>
        </Popconfirm>
      )}
    </Space>
  );
};
